var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"wrap box-shadow"},[_c('div',{staticClass:"row align-items-center img-panel"},[_c('div',{staticClass:"col text-center my-3"},[_c('h1',[_vm._v(_vm._s(_vm.$t("home.welcome")))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }